import { Box } from '@mui/material';
import myGif from 'components/Loading/solinloading.gif';

const Loading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '25rem',
      }}>
      <Box
        component="img"
        sx={{ width: 'auto', height: '10rem' }}
        src={myGif}
        alt="Loading..."
      />
    </Box>
  );
};

export default Loading;
